"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
class Error {
    constructor({ message, status }) {
        this.message = message;
        this.status = status;
    }
}
exports.Error = Error;
//# sourceMappingURL=types.js.map